import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { onlyNumbers, phoneNumber } from 'utils/format'
import { TELEPHONE } from 'constants/objects/telephone'
import { Form as FormComponent } from 'components/Form'
import {
  TitleForm,
  InputForm,
} from 'components/Form/components'
import { PhoneFields } from './styles'

export default function PhonesForm(props) {
  const {
    telephones,
    onCancel,
    onSave,
    saving,
  } = props

  const [attributes, setAttributes] = useState([])

  useEffect(() => {
    let phones = [...telephones]
    if (!phones.length) {
      phones = [TELEPHONE, TELEPHONE]
    }

    setAttributes(phones)
  }, [telephones])

  const handleSave = () => {
    onSave(attributes)
  }

  const handleChange = (evt, index) => {
    const { value, name } = evt.target
    let val = value

    if (name === 'number') {
      val = onlyNumbers(val).substr(0, 11)
    }

    const clone = [...attributes]
    clone[index] = {
      ...clone[index],
      [name]: val,
    }

    setAttributes(clone)
  }

  const renderTelephone = (phone, index) => (
    <PhoneFields key={`form-phone-${index}`}>
      <InputForm
        label="Descrição"
        placeholder="Celular, Residencial, etc"
        name="description"
        value={phone.description}
        onChange={(evt) => handleChange(evt, index)}
      />
      <InputForm
        label="Número"
        name="number"
        value={phoneNumber(phone.number)}
        onChange={(evt) => handleChange(evt, index)}
      />
    </PhoneFields>
  )

  return attributes?.length ? (
    <FormComponent
      onCancel={onCancel}
      onSave={handleSave}
      saving={saving}
    >
      <TitleForm>Telefones</TitleForm>

      {attributes.map((item, index) => renderTelephone(item, index))}
    </FormComponent>
  ) : null
}

PhonesForm.propTypes = {
  telephones: PropTypes.arrayOf(PropTypes.object).isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool,
}

PhonesForm.defaultProps = {
  saving: false,
}
